import React from "react";

interface RedirectPageProp {
  url: string | undefined;
}

const RedirectPage = ({ url }: RedirectPageProp): null => {
  React.useEffect(() => {
    window.location.replace(url as string);
  }, []);
  return null;
};

export default RedirectPage;
